export const CONTEXT_FILE_MAX_BYTES = 20 * 1024 * 1024

const CONTEXT_ALLOWED_EXTENSIONS = new Set(['pdf', 'docx', 'pptx', 'xlsx', 'html', 'htm'])

const CONTEXT_ALLOWED_MIME_TYPES = new Set([
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/html',
])

export type ContextFileValidationError = 'type' | 'size'

export function getFileExtension(filename: string): string {
  const parts = filename.trim().toLowerCase().split('.')
  return parts.length > 1 ? (parts.at(-1) ?? '') : ''
}

export function isAllowedContextFile(file: File): boolean {
  const extension = getFileExtension(file.name)
  if (CONTEXT_ALLOWED_EXTENSIONS.has(extension)) return true
  if (file.type && CONTEXT_ALLOWED_MIME_TYPES.has(file.type)) return true
  return false
}

export function validateContextFile(file: File): ContextFileValidationError | null {
  if (!isAllowedContextFile(file)) return 'type'
  if (file.size > CONTEXT_FILE_MAX_BYTES) return 'size'
  return null
}

export const CONTEXT_FILE_ACCEPT =
  '.pdf,.docx,.pptx,.xlsx,.html,.htm,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/html'
